import { Box, useMediaQuery, useTheme } from '@mui/material';

type Props = {
  listeners?: any;
  attributes?: any;
  isDragging?: boolean;
};

export const DragHandle = ({ listeners, attributes, isDragging }: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      {...listeners}
      {...attributes}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
        padding: { xs: '2px', sm: '4px' },
        marginRight: { xs: '8px', sm: '12px' },
        cursor: isDragging ? 'grabbing' : 'grab',
        opacity: isMobile ? 0.5 : 0.3,
        transition: 'opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        color: 'text.secondary',
        touchAction: 'none',
        flexShrink: 0,

        '&:hover': {
          opacity: 0.6
        },

        '&:active': {
          opacity: 0.8
        }
      }}
    >
      <Box
        sx={{
          width: { xs: 14, sm: 16 },
          height: 2,
          backgroundColor: 'currentColor',
          borderRadius: 1,
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      />
      <Box
        sx={{
          width: { xs: 14, sm: 16 },
          height: 2,
          backgroundColor: 'currentColor',
          borderRadius: 1,
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      />
      <Box
        sx={{
          width: { xs: 14, sm: 16 },
          height: 2,
          backgroundColor: 'currentColor',
          borderRadius: 1,
          transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)'
        }}
      />
    </Box>
  );
};
